import React from 'react';
import { Button as Btn } from 'react-bootstrap';
import Icon from '../icon';

function Button({ text, icon, variant, classes, handleClick, disabled = false }) {
  return (
    <Btn disabled={disabled} className={`btn-ue ${classes}`} variant={variant} onClick={handleClick}>
      {text}
      {icon &&
        <Icon classes="sm" icon={icon} />
      }
    </Btn>)
}

export default Button;